<!--
 * @Author: hzm
 * @Date: 2022-12-14 14:18:05
 * @Description: 
-->
<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="dialogOpen" :title="title" width="800px" append-to-body
    custom-class="pub-dialog">
    <div v-html="content"></div>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  content: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '消息详情',
  },
});
const emits = defineEmits(['update:open']);

const dialogOpen = computed({
  get: () => {
    return props.open;
  },
  set: v => {
    emits('update:open', false);
  },
});
function submit() {
  dialogOpen.value = false;
}
function cancel() {
  dialogOpen.value = false;
}
</script>
